import { Input, Menu, message, Modal, Spin } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ReactComponent as LabelIcon } from '@/assets/img/table/label.svg'
import { ReactComponent as DeleteSvg } from '@/assets/img/icon/delete.svg'
import { ReactComponent as EditIcon } from '@/assets/img/table/edit.svg'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import './index.less'
import labelApi from '@/api/label'

const { confirm } = Modal
const { SubMenu } = Menu

const LabelMenu = () => {
  const [showEditLabel, setShowAddLabel] = useState(false)
  const [loadingObj, setLoadingObj] = useState({ listLoading: false, modalLoading: false })
  const [labelList, setLabelList] = useState<any[]>([])
  const [newLabelName, setNewLabelName] = useState('')
  const [errorTip, setErrorTip] = useState('')
  const [actType, setActType] = useState('Add') //当前操作 添加 编辑
  const [actId, setctId] = useState(null) // 当前操作 label id
  const [inLabelMenu, setInLabelMenu] = useState(false)
  const history = useHistory()

  useEffect(() => {
    getLabelList()
  }, [])

  //关闭时候清空输入
  useEffect(() => {
    if (!showEditLabel) {
      setNewLabelName('')
      setErrorTip('')
    }
  }, [showEditLabel])

  useEffect(() => {
    if (history.location.pathname.includes('label')) {
      setInLabelMenu(true)
    } else {
      setInLabelMenu(false)
    }
  }, [history.location.pathname])

  const handleMenu = (e: any) => {
    if (e.key === 'Add') {
      setActType('Add')
      setShowAddLabel(true)
    } else {
      const tag = labelList.find((it) => it.id == e.key) || {}
      history.push(`/page/label/${e.key}`, { labelName: tag.labelName })
    }
  }

  const handleAfterOK = (type: string) => {
    getLabelList()
    setShowAddLabel(false)
    message.success(`${type} successfully`)
  }

  //获取列表
  const getLabelList = async () => {
    setLoadingObj({ ...loadingObj, listLoading: true })
    const list = (await labelApi.getLabelList()) as {}[]
    setLabelList(list)
    setLoadingObj({ listLoading: false, modalLoading: false })
  }

  //添加 编辑 标签
  const handleLabel = async () => {
    const has = labelList.some((it) => it.labelName === newLabelName)
    if (has) {
      setErrorTip('The label name you have chosen already exists. Please try another name.')
      return
    }
    setLoadingObj({ ...loadingObj, modalLoading: true })
    const type = actType === 'Add' ? 'addLabel' : 'editLabel'
    const data = actType === 'Add' ? newLabelName : { labelId: actId, labelName: newLabelName }
    //@ts-ignore
    await labelApi[type](data)
    handleAfterOK(actType)
  }

  //删除标签
  const handleDeleteLabel = async (id: number) => {
    confirm({
      title: `Do you want to delete this label?`,
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      cancelText: 'No',
      content: '',
      onOk() {
        return new Promise(async (resolve, reject) => {
          await labelApi.deleteLabel(id)
          handleAfterOK('Delete')
          resolve(true)
        }).catch(() => console.log('errors!'))
      },
      onCancel() {},
    })
  }

  const pathName = useMemo(() => {
    const pathList = history.location.pathname.split('/')
    return pathList[pathList.length - 1]
  }, [history.location.pathname])

  return (
    <>
      <Spin spinning={loadingObj.listLoading}>
        <Menu
          mode="inline"
          onClick={(e) => handleMenu(e)}
          selectedKeys={[pathName]}
          className={`label-mange-cont ${inLabelMenu ? '' : 'm-hide'}`}
        >
          <SubMenu key="sub1" title="Labels" icon={<LabelIcon />}>
            {labelList.map((it: any) => {
              return (
                <Menu.Item key={it.id} icon={<LabelIcon />}>
                  <div className="label-name">{it.labelName}</div>
                  <EditIcon
                    onClick={(e) => {
                      e.stopPropagation()
                      setActType('Edit')
                      setShowAddLabel(true)
                      setNewLabelName(it.labelName)
                      setctId(it.id)
                    }}
                    className="edit-icon"
                  />
                  <DeleteSvg
                    onClick={(e) => {
                      e.stopPropagation()
                      handleDeleteLabel(it.id)
                    }}
                    className="delete-icon"
                  />
                </Menu.Item>
              )
            })}
            {/* 添加按钮 */}
            <Menu.Item key="Add" className="create-new-item">
              <div className="create-new flex-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  style={{ marginRight: 6 }}
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 6V14"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 10L14 10"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Create New
              </div>
            </Menu.Item>
          </SubMenu>
        </Menu>
      </Spin>
      {/* 添加标签弹框 */}
      <Modal
        width={530}
        title={actType === 'Add' ? 'New Label' : 'Modify Label'}
        visible={showEditLabel}
        okText={actType === 'Add' ? 'Create' : 'Save'}
        okButtonProps={{ disabled: !newLabelName.length || !!errorTip }}
        confirmLoading={loadingObj.modalLoading}
        onOk={handleLabel}
        onCancel={() => setShowAddLabel(false)}
      >
        <Input
          placeholder="Label Name (64 char max)"
          onFocus={() => setErrorTip('')}
          value={newLabelName}
          maxLength={64}
          onInput={(e: any) => setNewLabelName(e.target.value)}
        />
        <p className="l-error-tip">{errorTip}</p>
      </Modal>
    </>
  )
}

export default LabelMenu
